import type { FunctionComponent } from "react";

import {
    KeywordsSharingModal,
    transformAccountUsers,
} from "app/pages/keyword-research/keyword-analysis/pages/monitor-lists/KeywordsSharingModal";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";
import { EAvailabilityMode } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { useAccountUsers } from "app/custom-hooks/useAccountUsers";
import { KeywordGroupsShareModal } from "app/pages/workspace/marketing/pages/KeywordGroupShareModal";

interface IAutocompleteDemandAnalysisShareModalProps {
    isOpen: boolean;
    groupToShare: IUserKeywordGroup | null;
    onClose: () => void;
}

export const AutocompleteDemandAnalysisShareModal: FunctionComponent<IAutocompleteDemandAnalysisShareModalProps> = ({
    isOpen,
    groupToShare,
    onClose,
}) => {
    const { data: accountUsers = [] } = useAccountUsers();

    const isKeywordListSmartSharingFeatureDisabled =
        swSettings.components?.KeywordAnalysis?.resources?.KeywordListSmartSharingFeature === EAvailabilityMode.HIDDEN;

    if (!isOpen || !groupToShare) {
        return null;
    }

    if (isKeywordListSmartSharingFeatureDisabled) {
        return (
            <KeywordGroupsShareModal
                keywordGroup={groupToShare}
                isOpen={isOpen}
                users={accountUsers}
                onCloseClick={onClose}
                onFinish={onClose}
            />
        );
    }

    return (
        <KeywordsSharingModal
            isOpen={isOpen}
            keywordGroup={groupToShare}
            users={transformAccountUsers(accountUsers)}
            onCloseClick={onClose}
            onSubmit={onClose}
        />
    );
};
